import { render, staticRenderFns } from "./PagamentoAprovarReprovar.vue?vue&type=template&id=64dbf356"
import script from "./PagamentoAprovarReprovar.vue?vue&type=script&lang=js"
export * from "./PagamentoAprovarReprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports